<div class="wrapper cv-dialog-form organization-container">
	<div class="row">
		<div class="col-sm-6">
			<cv-input
				(controlKeyup)="packageData.title = $event.value.trim()"
				[value]="packageData.title"
				[label]="'Title'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[required]="true"
				[placeholder]="'Title'"
			></cv-input>
			<cv-input
				(controlKeyup)="packageData.packageName = $event.value.trim()"
				[value]="packageData.packageName"
				[label]="'Package Name'"
				[type]="'text'"
				[name]="'name'"
				[minlength]="1"
				[required]="true"
				[placeholder]="'Package name'"
			></cv-input>
			<div class="product-check-container">
				<cv-switch
					[class]="'cv-switch-blue'"
					[checked]="packageData.active"
					[size]="'sm'"
					(valueChange)="activateInsideMaps($event)"
				></cv-switch>
				<span>Active</span>
			</div>
		</div>
		<div class="col-sm-6 cv-input">
			<cv-dropdown
				[required]="true"
				[label]="'Assign To'"
				[placeholder]="'Select an option'"
				[selectedValue]="assignToSelected"
				[options]="assignToList"
				[optionText]="'name'"
				(valuesChange)="onAssignToSelected($event)"
			>
			</cv-dropdown>
			<cv-dropdown
				[required]="true"
				[label]="'Access Level'"
				[placeholder]="'Select an access level'"
				[selectedValue]="accessLevelSelected"
				[options]="accessLevelList"
				[optionText]="'name'"
				(valuesChange)="onAccessLevelSelected($event)"
			>
			</cv-dropdown>
		</div>
	</div>
</div>
